import { PoiVehicleOutputWithStatus } from './poi-vehicle-output-with-status.model';


export class PoiVehicleSelectByIdOutput implements IPoiVehicleSelectByIdOutput {
    status!: number;
    message!: string;
    data!: PoiVehicleOutputWithStatus;

    constructor(data?: IPoiVehicleSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? PoiVehicleOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PoiVehicleSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiVehicleSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPoiVehicleSelectByIdOutput {
    status: number;
    message: string;
    data: PoiVehicleOutputWithStatus;
}

